import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import * as Sentry from '@sentry/angular-ivy';
import { environment } from './environments/environment';
import { ConfigService } from './app/config/config.service';

ConfigService.initialize().then(() => {
	if (environment.production) {
		enableProdMode();
	}

	Sentry.init({
		dsn: environment.sentryDSN,
		environment: environment.environment,
		attachStacktrace: true,
		enabled: environment.sentryEnabled,
	});

	platformBrowserDynamic()
		.bootstrapModule(AppModule)
		.catch((err) => console.error(err));
});
